module.exports = __webpack_public_path__ + "img/file-----3289-1x-png-2@1x.f8a0c98e.png";